import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export const Greeting = () => {
  const { currentUser } = useAuth();
  const name = currentUser ? currentUser.displayName || currentUser.email || 'Friend' : 'Guest';

  return (
    <div className="greeting-pill">
      <span>Hello, {name}!</span>
    </div>
  );
};

export default Greeting;
